export const useLayoutRegion = (
  region: MaybeRefOrGetter<LayoutRegion>,
  binds: MaybeRefOrGetter<LayoutRegionBinds> = {},
) => {
  const regionStore = useLayoutRegionStore();

  const layoutRegion = computed(() => regionStore.getRegion(toValue(region)));
  const layoutRegionRef = computed<LayoutRegionValue>(() => layoutRegion.value?.content);

  const layoutRegionBinds = computed(() => {
    return {
      ...layoutRegion.value?.binds,
    };
  });

  const setLayoutRegion = (content: LayoutRegionValue) => {
    regionStore.setRegion(toValue(region), content, toValue(binds));
  };

  return {
    layoutRegionRef,
    layoutRegionBinds,
    setLayoutRegion,
  };
};
